exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-visible[data-v-654746a6],\n.filter-invisible[data-v-654746a6]:hover {\n    color: #000;\n}\n.filter-invisible[data-v-654746a6],\n.filter-visible[data-v-654746a6]:hover {\n    color: #909090;\n}\n", ""]);

// exports
